module.exports = __webpack_public_path__ + "img/si.de48c381.svg";